import React from "react"
import { Box } from "datastory-shared/ui"

export const PageContent = props => <Box minHeight="500px" {...props} />
